export enum RouteName {
    ROOT = "/",
    ONBOARDING = "/onboarding",
    ONBOARDING_PROGRAM= "/onboarding-program",
    GAS_REBATE = "/gas-rebate",
    TESTNET_COMPETITION = "/testnet-competition",
    LIQUIDITY_MINING_LIST = "/liquidity-mining",
    LIQUIDITY_MINING_PAIR = "/liquidity-mining/:base::quote",
    SEED_ALLOCATION = "/seed-allocation",
}
